import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import { CopilotConfigDto } from '../queries';
import { CopilotConfigForm } from './CopilotConfigForm';

interface Props {
  open: boolean;
  agencyId: number;
  config?: CopilotConfigDto;
  onClose: () => void;
}

export const CopilotConfigModal = ({
  open,
  agencyId,
  config,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {config
          ? t('copilot.configs.modal.editTitle')
          : t('copilot.configs.modal.createTitle')}
        <IconButton onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <CopilotConfigForm agencyId={agencyId} config={config} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
